// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1_GeM","row":"ProcedureTreatmentSummary_row__28qk9"};